export default [
  'clickAddAnotherUser',
  'clickManageUsers',
  'clickNoThanks',
  'clickUpgradeNowBanner'
]
